module.exports = __webpack_public_path__ + "static/media/Solar Farm Login.fb02f3f8.png";